import { render } from "./VariantSelector.vue?vue&type=template&id=45d03967&scoped=true"
import script from "./VariantSelector.vue?vue&type=script&lang=js"
export * from "./VariantSelector.vue?vue&type=script&lang=js"

import "./VariantSelector.vue?vue&type=style&index=0&id=45d03967&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45d03967"]])

export default __exports__